export default __webpack_public_path__ + "static/media/joinUsBg.266780a4.svg";